import { RefreshCw, Save } from "lucide-react";
import { Button } from "@/components/ui/button";

export const UpdateAvailableBanner = ({ currentVersion, latestVersion }) => {
  if (!latestVersion) return null;

  return (
    <div className="sticky top-[65px] z-10 border-b border-sky-200 bg-sky-50/95 px-4 py-2.5 shadow-sm backdrop-blur sm:top-[73px] sm:px-8"
      data-testid="update-available-banner" role="status">
      <div className="mx-auto flex max-w-[1600px] flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex min-w-0 items-start gap-3 sm:items-center">
          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-slate-900 text-amber-400">
            <RefreshCw className="h-4 w-4" />
          </span>
          <div className="min-w-0">
            <p className="text-sm font-extrabold text-slate-900" data-testid="update-available-title">
              新版本 {latestVersion} 已上线
            </p>
            <p className="flex items-center gap-1.5 text-xs leading-5 text-slate-600" data-testid="update-available-message">
              <Save className="h-3.5 w-3.5 shrink-0" />
              请先保存当前资料，再刷新更新。当前版本为 {currentVersion}。
            </p>
          </div>
        </div>
        <Button type="button" size="sm" onClick={() => window.location.reload()}
          data-testid="refresh-for-update-button" className="w-full shrink-0 bg-slate-900 font-bold text-white hover:bg-slate-800 sm:w-auto">
          <RefreshCw className="mr-2 h-4 w-4" />刷新更新
        </Button>
      </div>
    </div>
  );
};